import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../../../Components/SelectField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateDivisionDialog = ({
  DshandleClose,
  Dsopen,
  DivisionUnit,
  setDivision,
  AllEmployee,
  createDivision,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={DshandleClose}
      aria-labelledby="customized-dialog-title"
      open={Dsopen}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={DshandleClose}
      >
        <div className="foundation_header">Create Division</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={DivisionUnit.name}
              onChange={(e) =>
                setDivision({ ...DivisionUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Division</label>
            <SelectField
              name="hod"
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  hod: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === DivisionUnit?.hod
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={DivisionUnit.description}
              onChange={(e) =>
                setDivision({ ...DivisionUnit, description: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={DivisionUnit.effective_status}
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose division</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={DivisionUnit.effective_start_date}
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={DshandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createDivision}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditDivisionDialog = ({
  handleEditDsClose,
  editDs,
  DivisionUnit,
  setDivision,
  AllEmployee,
  isLoading,
  updateDivision
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditDsClose}
      aria-labelledby="customized-dialog-title"
      open={editDs !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditDsClose}
      >
        <div className="foundation_header">Edit Division</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={DivisionUnit.name}
              onChange={(e) =>
                setDivision({ ...DivisionUnit, name: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Head of Division</label>
            <SelectField
              name="hod"
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  hod: e.value,
                })
              }
              options={AllEmployee}
              value={AllEmployee?.find(
                (item) => item?.value === DivisionUnit?.hod
              )}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={DivisionUnit.description}
              onChange={(e) =>
                setDivision({ ...DivisionUnit, description: e.target.value })
              }
            />
          </div>

          {/* <div className="Box">
            <label>effective Status</label>
            <select
              name="effectiveStatus"
              value={DivisionUnit.effective_status}
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  effective_status: e.target.value,
                })
              }
              id=""
            >
              <option value="">Choose division</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="Box">
            <label>effective Start Date</label>
            <input
              type="date"
              name=""
              id=""
              value={DivisionUnit.effective_start_date}
              onChange={(e) =>
                setDivision({
                  ...DivisionUnit,
                  effective_start_date: e.target.value,
                })
              }
            />
          </div> */}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditDsClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateDivision}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteDivisionDialog = ({
  handleDeleteDsClose,
  deleteDs,
  isLoading,
  deleteDivision,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteDsClose}
      aria-labelledby="customized-dialog-title"
      open={deleteDs !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteDsClose}
      >
        <div className="foundation_header">Delete Division</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteDsClose} className="Btn">
            Cancel
          </button>
          <button
            className="Delete_Btn"
            onClick={deleteDivision}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewDivisionDialog = ({
  handleViewDsClose,
  DsViewopen,
  employee,
}) => {
  return (
    <BootstrapDialog
      onClose={handleViewDsClose}
      aria-labelledby="customized-dialog-title"
      open={DsViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewDsClose}
      >
        <div className="foundation_header">View Division</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{DsViewopen?.name}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Head of Division</label>
            <p>{`${employee?.label}`}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{DsViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
